import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostPresentCancel = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CANCEL_PRESENT
            });
            dispatch(Action.SetGetPresentList({
                page: 1,
                rowsPerPage: 10,
                search: ''
            }));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostPresentCancel as SetPostPresentCancel
}